module.exports = __webpack_public_path__ + "static/media/profile.28d8f772.png";